import * as React from 'react';
import { UserBanner } from "./common/UserBanner";
import { BenefitsList } from './common/BenefitsList';
import { MembershipBenefitsList } from './common/MembershipBenefitsList';

import { FAQSection } from './common/FAQSection';
import { useCallback, useEffect, useState } from "react";
import { MembershipCard } from "./MembershipCard";
import { membershipTypes,contactInfo, userInfo, benefits,MembershipBenefits , faqs } from './MembershipLavelData';
import { Link } from 'react-router-dom';
import MembershipProgress from './common/MembershipProgress';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { responseNotification } from '../../utils/notify';
 
export const MembershipLavelPage: React.FC = () => {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  const [merchantDetailsInfo, setMerchantDetailsInfo] = useState<any>();
  const [memberShipLavelId, setMemberShipLavelId] = useState<any>();
  const [personalDetailsCheck, setPersonalDetailsCheck] = useState<any>();
  const userProfilePic = "https://cdn.builder.io/api/v1/image/assets/TEMP/7db1df81aaba85dfcce8c94cab2a88c7306a9d003417116f2be65bc69809587a?placeholderIfAbsent=true&apiKey=61022fe3774e4aa287a6264de6b79c87";
  const [merchantLavelDetails, setMerchantLavelDetails] = useState<any>();
  const fetchMerchantDetails = useCallback(() => {
    try {
      setPersonalDetailsCheck({ loading: true, data: null });
      axios
        .get(`${process.env.REACT_APP_RIDER_API}/details`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((data) => {
          if (data.status === 200) {
            setPersonalDetailsCheck({
              loading: false,
              data: data?.data?.merchant?.merchantPersonalDetail,
            });
            setMerchantDetailsInfo(data?.data?.merchant);
            setMemberShipLavelId(data?.data?.merchant?.membershipLevelId);
          } else {
            setPersonalDetailsCheck({ loading: false, data: null });
            responseNotification(data.statusText || "something went wrong", "error");
          }
        })
        .catch(() => {
          setPersonalDetailsCheck({ loading: false, data: null });
        });
    } catch {
      setPersonalDetailsCheck({ loading: false, data: null });
    }
  }, [token]);

  const fetchMemberShipLavelDetails = useCallback(() => {
    try {
      setMerchantLavelDetails({ loading: true, data: null });
      axios
        .get(`${process.env.REACT_APP_RIDER_API}/admin/membership/level/details?id=${memberShipLavelId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((data) => {
          if (data.status === 200) {
            setMerchantLavelDetails(data?.data?.membershipLevel);
          } else {
            setMerchantLavelDetails({ loading: false, data: null });
            responseNotification(data.statusText || "something went wrong", "error");
          }
        })
        .catch(() => {
          setMerchantLavelDetails({ loading: false, data: null });
        });
    } catch {
      setMerchantLavelDetails({ loading: false, data: null });
    }
  }, [memberShipLavelId]);



  useEffect(() => {
    fetchMerchantDetails();
    fetchMemberShipLavelDetails();
  }, [fetchMerchantDetails,fetchMemberShipLavelDetails]);
  
  return (
    <div className="flex overflow-hidden flex-col items-center bg-stone-50 pb-[50px] max-md:pb-24">
     <UserBanner
        userId={merchantDetailsInfo?.walletId || "JM 5421547"}
        userProfile={merchantDetailsInfo?.profilePicture || userProfilePic}
        userName={
          merchantDetailsInfo?.merchantPersonalDetail?.fullName || "New User"
        }
        membershipInfo={{
          title: "Welcome to Jachai Seller Center",
          description: "Explore US of wih a new seller and more benefits",
          ctaText: <Link to="/membership-upgrade">Explore</Link>,
        }}
        verificationStatus="our team is review your Documents. Expect a response within 72 hours. Thank you for your patience."
      />

      <div className="flex flex-wrap gap-5 justify-between py-2.5 pr-5 pl-20 mt-8 max-w-full font-bold bg-orange-100 rounded-xl shadow-sm w-[970px] max-md:pl-5">
        <div className="flex gap-5 text-zinc-800">
          <img
            loading="lazy"
            src={merchantLavelDetails?.logo}
            alt="User level icon"
            className="object-contain shrink-0 w-20 rounded-none aspect-square"
          />
          <div className="flex flex-col self-start">
            <div className="self-start text-sm font-medium">
              You are a Jachai
            </div>
            <div className="mt-1 text-base max-md:mr-1.5">{merchantLavelDetails?.name} USER</div>
            <div className="flex gap-0.5 mt-1 text-xs">
              <div className="grow">{merchantLavelDetails?.pointAmount} Pts</div>
              
            </div>
          </div>
        </div>
        <Link to="/membership">
        <button className="self-start px-5 py-1.5 mt-1.5 text-sm text-center text-cyan-700 whitespace-nowrap bg-white rounded-md max-md:pl-5">
          Update
        </button>
        </Link>
      </div>
      <div className="flex flex-col py-7 pr-1.5 mt-6 max-w-full text-sm font-medium text-black bg-white rounded-xl shadow-sm w-[970px]">
      <MembershipProgress/>
        <div className="self-start mt-3 ml-6 max-md:ml-2.5">
          Redeeming points won't affect your progress to the next level
        </div>
      </div>
      <BenefitsList benefits={benefits} />
      <MembershipBenefitsList MembershipBenefits={MembershipBenefits} />
      
      <FAQSection faqs={faqs} />
    </div>
  );
};

export default MembershipLavelPage;